import { ImpedimentRegisterTemplate } from "../../Templates/ImpedimentRegisterTemplate";

export const ImpedimentRegister = () => {
    return <ImpedimentRegisterTemplate />
};